import { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Icon } from '../../shared/Icon'
import styles from './StatsDisclaimer.module.scss'

export const STATS_DISCLAIMER_TEXT =
  'Statistiques sur données pseudonymisées, actualisées périodiquement. Ne pas utiliser pour une décision médicale individuelle.'

/** Bouton « i » pleine hauteur, même rendu que l'icône info de la barre Dictée. */
export const StatsDisclaimer: FunctionComponent = () => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return
    const onDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) setIsOpen(false)
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [isOpen])

  return (
    <div ref={ref} className={styles.root}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setIsOpen((open) => !open)}
        title="Informations sur les données"
        aria-label="Informations sur les données"
        aria-expanded={isOpen}
        data-testid="button-stats_assistant-disclaimer"
      >
        <Icon icon="infoCircle" size="micro" color="currentColor" />
      </button>
      {isOpen && (
        <div className={styles.bubble} role="note" onMouseDown={(event) => event.stopPropagation()}>
          {STATS_DISCLAIMER_TEXT}
        </div>
      )}
    </div>
  )
}
